import get from 'lodash/get';
import { createRoot } from 'react-dom/client';

import PackWrapper from 'components/common/PackWrapper';
import MenuSearchContainer from 'components/menuSearch/MenuSearchContainer';
import { getStore } from 'store/configure';

const store = getStore();

document.addEventListener('DOMContentLoaded', () => {
  const rootElement = document.querySelector('#hc-menu-search-react-app');
  const root = createRoot(rootElement);
  const showUnconvertedLead = get(rootElement, 'dataset.showUnconvertedLead', '{}') === 'true';
  const planId = get(rootElement, 'dataset.planId', '{}');
  const mealPlanSlug = get(rootElement, 'dataset.mealPlanSlug', '{}');

  root.render(
    <PackWrapper rootElement={rootElement} store={store}>
      <MenuSearchContainer
        showUnconvertedLead={showUnconvertedLead}
        planId={planId}
        mealPlanSlug={mealPlanSlug}
      />
    </PackWrapper>
  );
});
